import { defineComponent, ref, computed, nextTick, resolveComponent, openBlock, createElementBlock, normalizeClass, Fragment, renderList, createBlock, mergeProps, withCtx, renderSlot, createTextVNode, toDisplayString, createCommentVNode, createVNode, withModifiers, createElementVNode } from 'vue';
import { v as ee } from '../OrAutocompleteV3-8c6de221.js';
import { OrButtonV3 as script$1 } from '../or-button-v3/index.js';
import { OrPopoverV3 as script$2 } from '../or-popover-v3/index.js';
import { OrTagV3 as script$3 } from '../or-tag-v3/index.js';
import '@vueuse/core';
import '@onereach/styles/screens.json';
import '@onereach/styles/tailwind.config.json';
import 'lodash/get';
import 'lodash/isElement';
import '../or-error-v3/index.js';
import '../or-hint-v3/index.js';
import '../or-icon-button-v3/index.js';
import '../or-icon-v3/index.js';
import '../or-tooltip-v3/index.js';
import '../or-input-box-v3/index.js';
import '../or-input-v3/index.js';
import '../OrInlineInputV3-061441a3.js';
import '../or-inline-input-box-v3/index.js';
import '../or-text-v3/index.js';
import '../or-label-v3/index.js';
import '../or-loader-v3/index.js';
import '../or-menu-item-v3/index.js';
import '@floating-ui/dom';
import '../or-bottom-sheet-v3/index.js';
import '../or-overlay-v3/index.js';
import '../or-teleport-v3/index.js';
import '../or-tag-input-v3/index.js';
import './index.js';

var TagsOverflow;
(function (TagsOverflow) {
  TagsOverflow["Wrap"] = "wrap";
  TagsOverflow["Scroll"] = "scroll";
  TagsOverflow["Hidden"] = "hidden";
})(TagsOverflow || (TagsOverflow = {}));

const Tags = [
// Layout
'layout-row',
// Overflow
'overflow-hidden',
// Spacing
'gap-sm',
// Theme
'theme-foreground-default', 'dark:theme-foreground-default-dark'];
const TagsContainer = [
// Layout
'layout-row', 'max-w-full',
// Spacing
'gap-sm', 'py-xs'];
const TagsContainerOverflows = {
  [TagsOverflow.Wrap]: [
  // Layout
  '!flex-wrap'],
  [TagsOverflow.Scroll]: [
  // Layout
  'overflow-y-auto',
  // todo: extract to plugin?
  '[&::-webkit-scrollbar]:hidden [-ms-overflow-style:\'none\'] [scrollbar-width:\'none\']'],
  [TagsOverflow.Hidden]: [
  // Overflow
  'overflow-hidden']
};
const TagsOverflowButton = [
// Typography
'typography-caption-regular'];
const TagsOverflowPopover = [
// Layout
'layout-row !flex-wrap !content-start overflow-y-auto',
// Box
'max-w-[192px] max-h-[340px]',
// Spacing
'px-md', 'py-md', 'gap-sm'];

function castToTagObject(tag) {
  if (typeof tag === 'string') {
    return {
      label: tag,
      value: tag
    };
  } else {
    return tag;
  }
}

var script = defineComponent({
  name: 'OrTags',
  components: {
    OrButton: script$1,
    OrPopover: script$2,
    OrTag: script$3
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    overflow: {
      type: String,
      default: () => TagsOverflow.Hidden
    },
    tagProps: {
      type: Object,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click', 'focus', 'blur', 'reset'],
  expose: ['root', 'container', 'overflowPopover', 'scrollToEnd'],
  setup(props) {
    // Refs
    const root = ref();
    const container = ref();
    // Props
    const overflowButton = ref();
    const overflowButtonRoot = computed(() => {
      var _a;
      return (_a = overflowButton.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    const overflowPopover = ref();
    const overflowPopoverRoot = computed(() => {
      var _a;
      return (_a = overflowPopover.value) === null || _a === void 0 ? void 0 : _a.root;
    });
    // Styles
    const rootStyles = computed(() => ['or-tags-v3', ...Tags]);
    const popoverStyles = computed(() => ['or-tags-popover-v3']);
    const containerStyles = computed(() => [...TagsContainer, ...TagsContainerOverflows[props.overflow]]);
    const overflowButtonStyles = computed(() => [...TagsOverflowButton]);
    const overflowPopoverStyles = computed(() => [...TagsOverflowPopover]);
    // State
    const {
      innerItems
    } = ee(container, {
      hide: false,
      threshold: 8
    });
    const localItems = computed(() => {
      return props.items.map(castToTagObject);
    });
    const overflowItems = computed(() => {
      return localItems.value.slice(innerItems.value.length);
    });
    // Methods
    function togglePopover() {
      overflowPopover.value.toggle();
    }
    function scrollToEnd() {
      nextTick(() => {
        var _a, _b;
        (_a = container.value) === null || _a === void 0 ? void 0 : _a.scrollTo({
          left: (_b = container.value) === null || _b === void 0 ? void 0 : _b.scrollWidth,
          behavior: 'smooth'
        });
      });
    }
    return {
      root,
      container,
      localItems,
      overflowButton,
      overflowButtonRoot,
      overflowPopover,
      overflowPopoverRoot,
      rootStyles,
      popoverStyles,
      containerStyles,
      overflowButtonStyles,
      overflowPopoverStyles,
      overflowItems,
      togglePopover,
      scrollToEnd
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrTag = resolveComponent("OrTag");
  const _component_OrButton = resolveComponent("OrButton");
  const _component_OrPopover = resolveComponent("OrPopover");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.localItems.length > 0 ? (openBlock(), createElementBlock("div", {
    key: 0,
    ref: 'container',
    class: normalizeClass(_ctx.containerStyles)
  }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.localItems, item => {
    return openBlock(), createBlock(_component_OrTag, mergeProps({
      ..._ctx.tagProps,
      ...item.tagProps
    }, {
      key: item.value,
      class: ['max-w-full'],
      onReset: $event => _ctx.$emit('reset', item.value)
    }), {
      default: withCtx(() => [renderSlot(_ctx.$slots, "tag", {
        item: item
      }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
      _: 2 /* DYNAMIC */
    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onReset"]);
  }), 128 /* KEYED_FRAGMENT */)), _ctx.overflow === 'wrap' ? renderSlot(_ctx.$slots, "tail", {
    key: 0
  }) : createCommentVNode("v-if", true)], 2 /* CLASS */)) : createCommentVNode("v-if", true), _ctx.overflow === 'hidden' && _ctx.overflowItems.length > 0 ? (openBlock(), createElementBlock(Fragment, {
    key: 1
  }, [createVNode(_component_OrButton, {
    ref: 'overflowButton',
    class: normalizeClass(_ctx.overflowButtonStyles),
    type: 'button',
    variant: 'link',
    color: 'inherit',
    disabled: _ctx.disabled,
    onClick: withModifiers(_ctx.togglePopover, ["stop"])
  }, {
    default: withCtx(() => [createTextVNode(" +" + toDisplayString(_ctx.overflowItems.length), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "disabled", "onClick"]), createVNode(_component_OrPopover, {
    ref: 'overflowPopover',
    class: normalizeClass(_ctx.popoverStyles),
    "custom-styles": _ctx.popoverStyles,
    trigger: _ctx.overflowButtonRoot
  }, {
    default: withCtx(() => [createElementVNode("div", {
      class: normalizeClass(_ctx.overflowPopoverStyles)
    }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.overflowItems, item => {
      return openBlock(), createBlock(_component_OrTag, mergeProps({
        ..._ctx.tagProps,
        ...item.tagProps
      }, {
        key: item.value,
        onReset: $event => _ctx.$emit('reset', item.value)
      }), {
        default: withCtx(() => [renderSlot(_ctx.$slots, "tag", {
          item: item
        }, () => [createTextVNode(toDisplayString(item.label), 1 /* TEXT */)])]),
        _: 2 /* DYNAMIC */
      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["onReset"]);
    }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["class", "custom-styles", "trigger"])], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true), _ctx.overflow !== 'wrap' || _ctx.items.length === 0 ? renderSlot(_ctx.$slots, "tail", {
    key: 2
  }) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-tags-v3/OrTags.vue";

export { script as OrTagsV3, TagsOverflow };
